import { Injectable, inject } from "@angular/core";
import {
  Database,
  equalTo,
  listVal,
  orderByChild,
  query,
  ref,
  push,
  set,
  get,
} from "@angular/fire/database";
import { Observable, catchError, from, map, of } from "rxjs";
import {
  IActualizarMostrar,
  IRemitente,
  IRemitenteDestinatario,
  IUsuario,
  IUsuarioEdit,
} from "../../../interfaces/catalogos.";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class UsuariosService {
  private database: Database = inject(Database);
  http = inject(HttpClient);
 
  cargarUsuarios(): Observable<IUsuario[]> {
    const refCatalogo = ref(this.database, "usuarios");
    // Consulta para obtener solo los usuarios activos
    const userQuery = query(refCatalogo, orderByChild("activo"), equalTo(true));

    return from(get(userQuery)).pipe(
      map((snapshot) => {
        if (!snapshot.exists()) {
          console.log("No active users found");
          return [];
        }
        const usuarios: IUsuario[] = [];
        snapshot.forEach((childSnapshot) => {
          const usuario = childSnapshot.val() as IUsuario;
          usuario.id = childSnapshot.key || "";
          usuarios.push(usuario);
        });
        const activos = usuarios.filter((usuario) => usuario.mostrar);
        const inactivos = usuarios.filter((usuario) => !usuario.mostrar);
        const sortedActivos = activos.sort((a, b) =>
          a.nombre.localeCompare(b.nombre)
        );
        const sortedInactivos = inactivos.sort((a, b) =>
          a.nombre.localeCompare(b.nombre)
        );
        console.log("sortedActivos", sortedActivos);
        console.log("sortedInactivos", sortedInactivos);

        console.log("toodos", [...sortedActivos, ...sortedInactivos]);
        return [...sortedActivos, ...sortedInactivos];
      })
    );
  }
  getUser(uid: string): Observable<IUsuario | null> {
    // Construct the reference to the specific user based on uid
    const refUsuario = ref(this.database, `usuarios/${uid}`);

    // Construct the query (if needed, orderByChild and equalTo could be omitted if you are fetching by key)
    const userQuery = query(refUsuario, orderByChild("activo"), equalTo(true));

    // Execute the query and return the data as an Observable
    return new Observable<IUsuario | null>((observer) => {
      get(refUsuario)
        .then((snapshot) => {
          if (snapshot.exists()) {
            // Retrieve the user data
            const userData = snapshot.val();
            observer.next(userData);
          } else {
            observer.next(null); // No user found with the provided uid
          }
          observer.complete();
        })
        .catch((error) => {
          observer.error(error); // Handle errors in the query
        });
    });
  }

  // async guardarUsuario(usuario: IUsuario): Promise<void> {
  //   try {
  //     const refCatalogo = ref(this.database, "usuarios");
  //     const nuevoRemitenteRef = push(refCatalogo);
  //     const nuevoRemitente: IUsuario = {
  //       ...usuario,
  //       id: nuevoRemitenteRef.key || "",
  //     };
  //     const data = await set(nuevoRemitenteRef, nuevoRemitente);
  //     console.log("User saved successfully:", data);
  //     return data;
  //   } catch (error) {
  //     console.error("Error saving user:", error);
  //   }
  // }

  guardarUsuario(usuario: IUsuario): Observable<any> {
    const payload = {
      nombre: usuario.nombre,
      email: usuario.mail,
      rol: usuario.rol,
      formaEnvio: usuario.formaEnvio,
      permisos: usuario.temas,
    };
    return this.http.post(`${environment.usuarios.nuevo}`, payload).pipe(
      map((data: any) => {
        console.log("data post", data);

        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log("error", error);

        const errorResponse = {
          error: error.error,
          message: error.message,
        };
        return of(errorResponse);
      })
    );
  }

  editarUsuario(payload: IUsuarioEdit): Observable<any> {
    return this.http.post(`${environment.usuarios.actualizar}`, payload).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log("error", error);

        const errorResponse = {
          error: error.error,
          message: error.message,
        };
        return of(errorResponse);
      })
    );
  }

  eliminarUsuario(uid: string): Observable<any> {
    return this.http.post(`${environment.usuarios.borrar}`, { uid }).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log("error", error);
        const errorResponse = {
          error: error.error,
          message: error.message,
        };
        return of(errorResponse);
      })
    );
  }

  actualizarMostar(payload: IActualizarMostrar) {
    return this.http
      .post(`${environment.usuarios.actualizarMostrar}`, payload)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: HttpErrorResponse) => {
          console.log("error", error);

          const errorResponse = {
            error: error.error,
            message: error.message,
          };
          return of(errorResponse);
        })
      );
  }

  updateRol(rol: string, uid: string) {
    return this.http.post(`${environment.usuarios.rol}`, { rol, uid }).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log("error", error);

        const errorResponse = {
          error: error.error,
          message: error.message,
        };
        return of(errorResponse);
      })
    );
  }
}
